export const SupportedLocales = [
  'en-us',
  'en-dbg', //debug locale, not for production use.
  'de-de',
  'es-es',
  'fr-fr',
  'it-it',
  'ja-jp',
  'ko-kr',
  'pt-br',
  'ru-ru',
  'zh-cn',
  'zh-tw',
] as const;

export type SupportedLocale = (typeof SupportedLocales)[number];

export interface LocaleStrings {
  locale: SupportedLocale;
  strings: Record<string, string>;
}
